import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import RouterRender from './router';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
function App() {
  return (
    <ConfigProvider componentSize="middle" locale={zh_CN}>
      <BrowserRouter>
        <RouterRender></RouterRender>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
